import React, { useCallback, useState, useEffect } from 'react';
import { Icon } from 'ui';
import RemoteAutoComplete from 'components/shared/RemoteAutoComplete';
import request from 'utils/request_ajax';
import { setQueryString } from 'utils/url';
import { routes } from 'constants/config';

const AccountExpert = ({ currentExpert }) => {
  const [expert, setExpert] = useState(currentExpert);
  const [loading, setLoading] = useState(false);

  async function handleExpertAdd(user) {
    try {
      setLoading(true);
      await request.post(
        routes.SETTINGS.UPDATE_COMPANY,
        {
          company: {
            settings: {
              learning_library_expert_id: user.id,
              learning_library_expert_uuid: user.uuid,
            },
          },
        },
        { dataType: 'script' },
      );
      setExpert(user);
    } finally {
      setLoading(false);
    }
  }

  const removeExpert = useCallback(() => setExpert(null), []);

  useEffect(
    () => pubsub.subscribe('company-settings-expert-removed', removeExpert),
    [removeExpert],
  );

  return (
    <>
      <div className="mb-8">
        <Icon name="expert" className="ExpertIcon ExpertIcon-contact" />
        <label
          className="ExpertForm-settingsLabel ml-4 mr-4"
          htmlFor="company_settings_learning_library_expert_id"
        >
          {t('settings.tab.global_lesson.learn_contact.title')}
        </label>
        <Icon
          name="info"
          className="ExpertIcon-tooltip"
          data-toggle="tooltip"
          tabIndex="0"
          data-original-title={t(
            'settings.tab.global_lesson.learn_contact.tooltip',
          )}
        />
      </div>
      {!expert && (
        <div className="w-240">
          <RemoteAutoComplete
            className="NewInput NewInput--light NewInput--fw learning_library_expert_input"
            placeholder={t(
              'settings.tab.global_lesson.learn_contact.placeholder',
            )}
            getSuggestionValue={suggestion => suggestion.name}
            mapResponseToSuggestions={response => response.owners}
            onSuggestionSelected={handleExpertAdd}
            renderSuggestion={suggestion => suggestion.name}
            url={setQueryString(routes.OWNERSHIPS_EXPERTS, { limit: 10 })}
            disabled={loading}
          />
        </div>
      )}
    </>
  );
};

// react-on-rails workaround to get hooks to work
export default props => <AccountExpert {...props} />;
